import { styled, Box } from '@mui/material';

interface TimerContainerProps {
  size: number;
}

export const TimerContainer = styled(Box)<TimerContainerProps>(({ size, theme }) => ({
  position: 'relative',
  width: size,
  height: size,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0, 
}));

export const SVG = styled('svg')({
  position: 'absolute',
  top: 0,
  left: 0,
});

export const CircleBackground = styled('circle')(({ theme }) => ({
  fill: 'none',
  stroke: 'transparent',
}));

export const CircleProgress = styled('circle')(({ theme }) => ({
  fill: 'none',
  stroke: theme.palette.orange.light,
  strokeLinecap: 'butt',
  transform: 'rotate(-90deg)',
  transformOrigin: 'center',
  transition: 'stroke-dashoffset 1s linear',
}));

export const TimeText = styled('span')(({ theme }) => ({
  position: 'absolute',
  color: theme.palette.common.white,
  fontSize: '0.625rem',
  fontWeight: 'bold',
}));